import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "global-search" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 1,
  class: "search-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchListItem = _resolveComponent("SearchListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isShowingResults || _ctx.searched!==_ctx.query)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          value: `Lookup "${_ctx.query}"?`,
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search())),
          class: "btn btn-plain btn-light global-search__button"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.t('search results')), 1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (word, idx) => {
      return (_openBlock(), _createBlock(_component_SearchListItem, {
        key: word.id,
        onClick: ($event: any) => (_ctx.genHandler(idx)),
        onKeydown: ($event: any) => (_ctx.genHandler(idx)),
        "is-selecting": false,
        word: word
      }, null, 8, ["onClick", "onKeydown", "word"]))
    }), 128))
  ]))
}